import { MeetingTemplatePage } from '@features/meeting-templates/components/MeetingTemplatePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/templates/')({ component: MeetingTemplatePage });
